var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[{ disabled: _vm.disabled }, 'textarea-container'],style:([
			{
				width: _vm.width
			}
		])},[(_vm.label.length)?_c('span',{staticClass:"textarea-label"},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_c('div',{class:[
				{ flat: _vm.flat, filled: _vm.filled },
				'textarea-wrapper',
				!_vm.flat && !_vm.filled ? 'default' : ''
			],style:([
				{
					'justify-content': _vm.alignPos
				}
			]),on:{"mouseenter":function($event){_vm.hover = true},"mouseleave":function($event){_vm.hover = false}}},[_c('div',{staticClass:"textarea-contents"},[(_vm.prependOuterIcon.length)?_c('Icon',{staticClass:"textarea-prepend-outer-icon",attrs:{"name":_vm.prependOuterIcon,"size":_vm.iconSize}}):_vm._e(),_c('div',{class:[
						{ filled: _vm.filled },
						'textarea-inside',
						!_vm.flat && !_vm.filled ? 'default' : '',
						_vm.hasFocus ? 'active' : 'idle'
					]},[(_vm.prependIcon.length)?_c('Icon',{staticClass:"textarea-prepend-icon",attrs:{"color":_vm.activeColor,"name":_vm.prependIcon,"size":_vm.iconSize}}):_vm._e(),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.val),expression:"val"}],ref:"input",class:[
							{ flat: _vm.flat, filled: _vm.filled },
							'textarea-value',
							!_vm.flat && !_vm.filled ? 'default' : '',
							_vm.hasFocus ? 'active' : 'idle'
						],style:([
							{
								color: _vm.activeColor
							}
						]),attrs:{"title":"","wrap":_vm.wrap,"placeholder":_vm.placeholder,"spellcheck":_vm.spellcheck,"rows":_vm.rows,"cols":_vm.cols,"tabindex":_vm.disabled ? '-1' : ''},domProps:{"value":(_vm.val)},on:{"blur":_vm.blur,"focus":_vm.focus,"input":[function($event){if($event.target.composing){ return; }_vm.val=$event.target.value},_vm.inputEvent],"mouseup":_vm.altFocus,"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }if(!$event.ctrlKey){ return null; }return _vm.submit($event)}}}),_vm._v(" "),_c('div',{staticClass:"textarea-resizer",class:[
							{ flat: _vm.flat, filled: _vm.filled },
							'textarea-value',
							!_vm.flat && !_vm.filled ? 'default' : '',
							_vm.hasFocus ? 'active' : 'idle'
						]},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16.41","height":"16.41","viewBox":"0 0 16.41 16.41"}},[_c('line',{staticClass:"resizer-svg",attrs:{"x1":"15.71","y1":"0.71","x2":"0.71","y2":"15.71"}}),_c('line',{staticClass:"resizer-svg",attrs:{"x1":"15.71","y1":"6.21","x2":"6.21","y2":"15.71"}}),_c('line',{staticClass:"resizer-svg",attrs:{"x1":"15.71","y1":"11.71","x2":"11.71","y2":"15.71"}})])]),(_vm.appendIcon.length)?_c('Icon',{staticClass:"textarea-append-icon",staticStyle:{"padding-right":"5px"},attrs:{"color":_vm.activeColor,"name":_vm.appendIcon,"size":_vm.iconSize}}):_vm._e()],1),(_vm.appendOuterIcon.length)?_c('Icon',{staticClass:"textarea-append-outer-icon",attrs:{"size":_vm.iconSize,"icon":_vm.appendOuterIcon}}):_vm._e()],1),_c('div',{staticClass:"indicator-wrapper",style:([
					{
						'justify-content': _vm.alignPos
					}
				])},[(!_vm.filled)?_c('div',{class:[
						_vm.hasFocus || _vm.hover ? 'active' : 'idle',
						'textarea-indicator'
					],style:([
						{
							background: _vm.hasFocus
								? _vm.realColor
								: 'var(--color-default)',
							height: _vm.underlineSize
						}
					])}):_vm._e()])])])}
var staticRenderFns = []

export { render, staticRenderFns }